export default __webpack_public_path__ + "static/media/Cartelsv.27f8a1f1.jpeg";